export default "__VITE_ASSET__L5ubHqdb__"